// 管理者ダッシュボード(設計書 §3.5.2)

import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '../client';

export type EventSeverity = 'info' | 'warning' | 'error' | 'critical';

export interface DashboardEvent {
  occurred_at: string;
  actor_label: string;
  action: string;
  severity: EventSeverity;
  message: string;
}

export interface AdminDashboard {
  active_sessions: number;
  max_sessions: number;
  online_servers: number;
  total_servers: number;
  performer_count: number;
  pending_approval_count: number;
  today_error_count: number;
  recent_events: DashboardEvent[];
}

export const adminDashboardKey = ['admin', 'dashboard'] as const;

export function useAdminDashboard() {
  return useQuery({
    queryKey: adminDashboardKey,
    queryFn: () => apiRequest<AdminDashboard>('/admin/dashboard'),
    refetchInterval: 30_000,
  });
}
